import { useQuery } from '@hooks/reactQuery';

import { getNetworkElements } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';

import { INetworkElementsListDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS } from '@constants/queryKeys';

const NETWORK_ELEMENTS_STALE_TIME = 5 * 60 * 1000;

interface IseQueryNetworkElementsReturned {
	networkElements: INetworkElement[];
	allNetworkElements: INetworkElement[];
	countOfRecords: number;
	isLoadingNetworkElements: boolean;
}

const useQueryNetworkElements = (params: INetworkElementsListDTO): IseQueryNetworkElementsReturned => {
	const {
		page,
		pageSize,
		isEnabled,
	} = params;

	const {
		data,
		allData,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS, params],
		queryFn: extractQueryParams(getNetworkElements),
		enabled: [!!page, !!pageSize, isEnabled],
		fetchAllData: true,
		...refetchOptions,
		staleTime: NETWORK_ELEMENTS_STALE_TIME,
	});

	return {
		networkElements: data?.items || [],
		allNetworkElements: allData?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingNetworkElements: (isLoading && !!data) || isFetching,
	};
};

export default useQueryNetworkElements;
